export default {
  title: "Құжаттар",
  instruction: "Нұсқаулар",
};
